import React, { Dispatch, SetStateAction } from "react";

interface EditServiceContextState {
  allowEditing: boolean;
  setAllowEditing: Dispatch<SetStateAction<boolean>>;
  saveValidationFailed: boolean;
  setSaveValidationFailed: Dispatch<SetStateAction<boolean>>;
  isSaving: boolean;
  setIsSaving: Dispatch<SetStateAction<boolean>>;
  isEditDisabled: boolean;
  setEditDisabled: Dispatch<SetStateAction<boolean>>;
}

const EditServiceContext = React.createContext<EditServiceContextState | undefined>(undefined);

EditServiceContext.displayName = "EditServiceContext";

const EditServiceContextProvider: React.FC = ({ children }) => {
  const [allowEditing, setAllowEditing] = React.useState(false);
  const [saveValidationFailed, setSaveValidationFailed] = React.useState(false);
  const [isEditDisabled, setEditDisabled] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);

  return (
    <EditServiceContext.Provider
      value={{
        allowEditing,
        setAllowEditing,
        saveValidationFailed,
        setSaveValidationFailed,
        isSaving,
        setIsSaving,
        isEditDisabled,
        setEditDisabled,
      }}
    >
      {children}
    </EditServiceContext.Provider>
  );
};

/**
 * Hook to use EditServiceContext
 */
const useEditServiceContext = () => {
  const context = React.useContext(EditServiceContext);

  if (!context) {
    throw new Error("useEditServiceContext is only allowed inside <EditServiceContextProvider />");
  }

  return context;
};

export { EditServiceContextProvider, useEditServiceContext };
